import actionTypes from '../../constants/actions/importarClientesExcel/importarClientesExcel'

export function submitImportarClientesExcel (value) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_CLIENTES_EXCEL,
    value
  }
}

export function submitImportarClientesExcelSuccess (listImportarClientesExcel) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_CLIENTES_EXCEL_SUCCESS,
    listImportarClientesExcel
  }
}

export function abrirModalImportarClientesExcel () {
  return {
    type: actionTypes.ABRIR_MODAL_IMPORTAR_CLIENTES_EXCEL
  }
}

export function cerrarModalImportarClientesExcel () {
  return {
    type: actionTypes.CERRAR_MODAL_IMPORTAR_CLIENTES_EXCEL
  }
}

export function subirArchivosImportarClientesExcel (archivoExcel) {
  return {
    type: actionTypes.SUBIR_ARCHIVOS_IMPORTAR_CLIENTES_EXCEL,
    archivoExcel
  }
}

export function descargarPlantillaExcelClientesExcel () {
  return {
    type: actionTypes.DESCARGAR_PLANTILLA_EXCEL_CLIENTES_EXCEL
  }
}

export default {
  submitImportarClientesExcel,
  submitImportarClientesExcelSuccess,
  abrirModalImportarClientesExcel,
  cerrarModalImportarClientesExcel,
  subirArchivosImportarClientesExcel,
  descargarPlantillaExcelClientesExcel
}